import React from 'react';
import { useQuery } from 'react-apollo';
import { Drawer, Table, Tag, Typography, Spin, Empty, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import GET_CAMPAING_ORDER_BASIC_DETAILS_CONNECTION from '../../../../../core/GraphQl/Queries/GET_CAMPAING_ORDER_BASIC_DETAILS_CONNECTION';
import StatusTag from '../../../Campaigns/shared/StatusTag';
import { TableColumnTitle } from '../../../../shared/globalStyling/styledText';

const { Text } = Typography;

const CampaignsDrawer = ({ visible, onClose, tagId, tagName }) => {
  const { data, loading, error } = useQuery(GET_CAMPAING_ORDER_BASIC_DETAILS_CONNECTION, {
    variables: {
      where: {
        transactionTarget: tagId,
      },
      first: 100,
      orderBy: 'startDate_DESC',
    },
    skip: !tagId || !visible,
    fetchPolicy: 'cache-and-network',
  });

  const campaigns =
    data?.campaignOrdersConnection?.edges?.map((edge) => ({
      ...edge.node,
      key: edge.node.id,
    })) || [];

  const columns = [
    {
      title: <TableColumnTitle text={'Name'} />,
      dataIndex: 'name',
      key: 'name',
      width: '45%',
      render: (text, record) => (
        <Row type="flex" justify="start">
          <Col style={{ width: '100%' }}>
            {record.advertiser && (
              <Row style={{ marginBottom: 4 }}>
                <Tag color="gray" style={{ fontSize: 11 }}>
                  {record.advertiser.name}
                </Tag>
              </Row>
            )}
            <Link
              to={`/campaigns/details/${record.id}/1`}
              onClick={(e) => e.stopPropagation()}
              style={{
                color: 'inherit',
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: 13,
              }}
            >
              {text}
            </Link>
          </Col>
        </Row>
      ),
    },
    {
      title: <TableColumnTitle text={'Status'} />,
      dataIndex: 'status',
      key: 'status',
      width: '20%',
      align: 'center',
      render: (status, record) => (
        <StatusTag
          startDate={record.startDate}
          endDate={record.endDate}
          attributionWindow={record.attributionWindow || 14}
          statusCampaign={status}
        />
      ),
    },
    {
      title: <TableColumnTitle text={'Start Date'} />,
      dataIndex: 'startDate',
      key: 'startDate',
      width: '17.5%',
      align: 'center',
      render: (date) => (
        <Text style={{ fontSize: 12, color: '#595959' }}>
          {date ? moment(date).format('MM/DD/YYYY') : 'N/A'}
        </Text>
      ),
    },
    {
      title: <TableColumnTitle text={'End Date'} />,
      dataIndex: 'endDate',
      key: 'endDate',
      width: '17.5%',
      align: 'center',
      render: (date) => (
        <Text style={{ fontSize: 12, color: '#595959' }}>
          {date ? moment(date).format('MM/DD/YYYY') : 'N/A'}
        </Text>
      ),
    },
  ];

  return (
    <Drawer
      title={
        <div>
          <Text strong style={{ fontSize: 16 }}>Campaigns using tag: </Text>
          <Text type="secondary" style={{ fontSize: 14 }}>{tagName}</Text>
        </div>
      }
      placement="right"
      width={750}
      onClose={onClose}
      open={visible}
      bodyStyle={{ padding: '16px 24px' }}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '50px 0' }}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <Empty description="Error loading campaigns" />
      ) : campaigns.length === 0 ? (
        <Empty description="No campaigns found using this tag" />
      ) : (
        <>
          <Text type="secondary" style={{ marginBottom: 16, display: 'block', fontSize: 13 }}>
            Found {campaigns.length} campaign{campaigns.length !== 1 ? 's' : ''}
          </Text>
          <div className="campaigns-drawer-table">
            <Table
              dataSource={campaigns}
              columns={columns}
              pagination={{
                pageSize: 10,
                showSizeChanger: campaigns.length > 10,
                size: 'small',
              }}
              size="small"
              rowClassName={(_record, index) =>
                index % 2 === 0 ? 'drawer-table-row-even' : 'drawer-table-row-odd'
              }
              onRow={() => ({
                style: { cursor: 'pointer' },
              })}
            />
          </div>
          <style>{`
            .campaigns-drawer-table .ant-table-thead > tr > th {
              background-color: #f0f0f0 !important;
              font-weight: 600;
              font-size: 12px !important;
              color: #262626 !important;
              border-bottom: 2px solid #d9d9d9 !important;
              padding: 10px 12px !important;
            }
            .campaigns-drawer-table .ant-table-tbody > tr > td {
              padding: 12px !important;
              border-bottom: 1px solid #f0f0f0 !important;
            }
            .campaigns-drawer-table .drawer-table-row-even {
              background-color: #fafafa;
            }
            .campaigns-drawer-table .drawer-table-row-odd {
              background-color: #ffffff;
            }
            .campaigns-drawer-table .ant-table-tbody > tr:hover > td {
              background-color: #f0f5ff !important;
            }
                      `}</style>
        </>
      )}
    </Drawer>
  );
};

export default CampaignsDrawer;
